export default __webpack_public_path__ + "media/color/evx-fbdc6386.svg";